export enum PriceType {
  MINUTE_REGULAR = 'minuteRegular',
  HOUR_REGULAR = 'hourRegular',
  DAY_REGULAR = 'dayRegular',
  WEEK_REGULAR = 'weekRegular',
  KM_REGULAR = 'kmRegular',
}

export const convertEuroToCents = (value: string) => +value * 100;
